import React from 'react';
import { LangContext } from '../contexts/lang.context';
import { Box, useTheme } from '@material-ui/core';
import { LanguageSwitcher } from '../i18n/components/LanguageSwitcher';
import logo from '../images/header-logo.png';

export const Header: React.FC = () => {
  const { APP } = React.useContext(LangContext).currentLangData;
  const primaryColor = useTheme().palette.primary.main;

  return (
    <Box display="flex" alignItems="center">
      {/* logo section */}
      <Box bgcolor={primaryColor} px="5px" pb={1}>
        <img src={logo} alt="Logo" style={{ height: '55px', margin: '6px -12px -8px -3px' }} />
        <span style={{ fontSize: '1.5rem', color: 'white' }}>
          <span style={{ fontWeight: 'bold' }}>{APP.confirmed}</span>
          <span>{APP.forest}</span>
        </span>
      </Box>

      {/* empty */}
      <Box flexGrow={1}></Box>

      {/* button section */}
      <Box p={1}>
        <LanguageSwitcher />
      </Box>
    </Box>
  );
};
